export const AUTOMATION_FAILURE_TYPES = Object.freeze({
  PAYMENT: 'payment',
  ADDRESS: 'address',
  PRODUCT: 'product',
  SHIPPING: 'shipping',
  OTHER: 'other',
});
